'use strict';
import React from 'react';
import Portal from 'react-portal';
import flux from 'utils/flux';
import LoginSlideshow from 'pages/login/loginSlideshow';
import LoginBackgroundVideo from 'pages/login/loginBackgroundVideo';
import Modal from 'components/modals/modal';
import AltContainer from 'alt-container';
import ConfirmEmailModal from 'components/modals/confirmEmailModal';

var ConfirmEmailPage = React.createClass({

    displayName: 'ConfirmEmailPage',

    mixins: [],

    propTypes: {},

    getInitialState() {
        return {};
    },

    renderFullbleed() {
        var isMobile = ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) );
        var backGroundLayer;

        if (!isMobile) {
            if( window.config.backgroundMovie.length>1 && window.config.backgroundMovie.indexOf("-")>1) {
                backGroundLayer = (
                    <LoginBackgroundVideo
                        poster={window.config.slideshowImages[0]}
                        video={window.config.backgroundMovie}
                    />
                );
            } else {
                backGroundLayer = (
                    <LoginSlideshow
                        show={window.config.slideshowImages}
                        speed={4000}
                    />
                );
            }

        } else {
            backGroundLayer = (
                <LoginSlideshow
                    show={window.config.slideshowImages}
                    speed={4000}
                />
            );
        }

        return backGroundLayer;
    },

    //
    // Try to submit the query data immediately even before rendering the modal
    componentWillMount() {
        var data = {email: this.props.query.email, code: this.props.query.code};
        if (this.props.query.email && this.props.query.code) {
            flux.getStore('app').confirmEmail(data).then(() => {
                this.setState({autoConfirmSuccess: true});
            });
        }
    },

    render() {
        return (
            <div className="welcome container--centered">
                <AltContainer
                    stores={{appStore: flux.getStore('app')}}
                    render={(props) => {
                        if (flux.getStore('app').isLoading()) {
                            return null;
                        }
                        var hasError = props.appStore.error;
                        return (
                            <Portal isOpened={true}>
                                <Modal className="modal__confirm-email" closeOnOutsideClick={false} hideCloseButton={true}>
                                    <ConfirmEmailModal hasError={hasError} autoConfirmSuccess={this.state.autoConfirmSuccess} {...this.props}/>
                                </Modal>
                            </Portal>
                        );
                    }}
                />
                <Portal isOpened={true}>
                   {this.renderFullbleed()}
                </Portal>
            </div>
        );
    }
});

module.exports = ConfirmEmailPage;



// WEBPACK FOOTER //
// ./app/pages/confirmEmail/index.jsx